import { memo, useEffect, useState, FC } from "react";
import {
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Textarea,
} from "@chakra-ui/react";
import { OrionType } from "../../../types/api/orionType";

type Props = {
  Type: OrionType | undefined;
  isOpen: boolean;
  loading: boolean;
  onClose: () => void;
};

export const OrionTypeModal: FC<Props> = memo((props) => {
  const { isOpen, onClose, Type } = props;

  useEffect(() => {
    onModalReset();
  }, [Type]);

  const onModalReset = () => {
    if (Type) {
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onModalReset();
        onClose();
      }}
      motionPreset="slideInBottom"
      autoFocus={false}
      size={"4xl"}
    >
      <ModalOverlay />
      <ModalContent pb={2}>
        <ModalHeader>Type状況</ModalHeader>
        <ModalCloseButton />
        <ModalBody mx={{ base: 0, md: 6 }}>
          {props.loading ? (
            <Center h="50vh">
              <Spinner color="teal.500" />
            </Center>
          ) : (
            <Textarea
              value={JSON.stringify(Type, null, 2)}
              readOnly={true}
              rows={20}
              border="1px"
              borderColor={"gray.400"}
            />
          )}
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
});
